import emojiRegex from "emoji-regex";
import { object, string, number, mixed, boolean, InferType } from "yup";

export const SchemaFileDataGenericValidation = object({
  type: string().nullable().default(""),
  size: number().default(0),
  file: mixed<File>().nullable().default(null),
  url: string().default(""),
  error: boolean().default(false),
  deleted: boolean().default(false),
  isNewFile: boolean().default(false),
  order: number().default(0),
  comment: string().test("no-emojis", "No se permiten emoticones", value => {
    const regex = emojiRegex();
    return !regex.test(value || "");
  }),
  progress: number().default(100),
  name: string().nullable().default(""),
  id: mixed<number | string>().default("")
}).default({});

export type IFileDataGeneric = InferType<typeof SchemaFileDataGenericValidation>;
